var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.accordions),function(accordion){return _c('Accordion',{key:accordion.title,attrs:{"title":accordion.title,"content":accordion.body}},[_vm._v("\n       "+_vm._s(accordion.body)+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }